import CustomTitleBar from 'src/components/GuideMeTitleBar';
import useCheckbookConfiguration from 'src/hooks/useCheckbookConfiguration';

const CommonSection = () => (
  <>
    <ul className="list-disc pl-8">
      <li className="pb-0.5">
        <div className="flex items-center [&>span]:border-b-2 [&>span]:border-[#1bc47d] [&>span]:inline-block [&>span]:mr-[1px] [&>span]:px-[1px]">
          <span>7</span>
          <span>2</span>
          <span>1</span>
          <span>0</span>-<span>1</span>
          <span>0 </span>
          <div className="ml-[5px] mt-0.5"> - Acceptable ✅</div>
        </div>
      </li>
      <li>
        <div className="flex items-center [&>span]:border-b-2 [&>span]:border-[#1bc47d] [&>span]:inline-block [&>span]:mr-[1px] [&>span]:px-[.6px]">
          <span className="!border-[red]">A</span>
          <span>6</span>
          <span>7</span>
          <span>8</span>-<span>1</span>
          <span>2</span>
          <div className="ml-[7px] mt-0.5"> - Not Acceptable ❌</div>
        </div>
      </li>
    </ul>
  </>
);

export const CanEditAttributes = () => (
  <div className="font-semibold text-sm">
    <ul className="px-4 list-disc [&>li]:mb-2">
      <li>
        Use <span className="text-[#0E80B4]">*</span> to denote any alphanumeric character (eg. A-Z
        OR 0-9 allowed)
      </li>
      <li>
        Use <span className="text-[#0E80B4]">#</span> to denote any number character (eg. 0-9
        allowed)
      </li>
      <li>
        Use <span className="text-[#0E80B4]">@</span> to denote any alpha character (eg. A-Z
        allowed)
      </li>
      <li>
        Use of the following special characters is allowed and will be treated as required
        separators - . _ ( )
      </li>
      <li>Use of numbers and letters will be treated literally</li>
      <li>
        Example format: <span className="text-[#0E80B4] tracking-[.13em]">####-##</span>
      </li>
    </ul>
    <CommonSection />
  </div>
);

export const CannotEditAttributes = () => (
  <div className="font-semibold text-sm">
    <ul className="px-4 list-disc [&>li]:mb-2">
      <li>
        <span className="text-[#0E80B4]">*</span> is used to require any alphanumeric character (eg.
        A-Z OR 0-9 allowed)
      </li>
      <li>
        <span className="text-[#0E80B4]">#</span> is used to require any number character (eg. 0-9
        allowed)
      </li>
      <li>
        <span className="text-[#0E80B4]">@</span> is used to require any letter character (eg. A-Z
        allowed)
      </li>
      <li>Use of other special characters are treated as required separators</li>
      <li>Use of numbers and letters are treated literally</li>
      <li>
        Example format: <span className="text-[#0E80B4] tracking-[.13em]">####-##</span>
      </li>
    </ul>
    <CommonSection />
  </div>
);

export const GLCodeGuideMeSteps = (isGuideMe: boolean) => {
  const { isPageEditable } = useCheckbookConfiguration();

  return [
    {
      title: (
        <CustomTitleBar
          title={`${
            isPageEditable ? 'Set Acceptable Format(s)' : 'Reviewing Acceptable Format(s)'
          }`}
          className={`${isGuideMe ? 'text-red-600' : ''} font-bold text-xl`}
        />
      ),
      content: isPageEditable ? <CanEditAttributes /> : <CannotEditAttributes />,
    },
  ];
};
